import React from "react";

export const UserLayoutContext = React.createContext({
    onUpgradeRequired: null,
    onPuzzleTitleChange: null,
    onPuzzleSubtitleChange: null,
    hasSiteAdBanner: false,
});
